var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-upload-btn",on:{"click":function($event){$event.stopPropagation();return _vm._chooseFile($event)}}},[_c('i',{staticClass:"icon-add"}),_c('span',{staticClass:"btn-text"},[_vm._v(_vm._s(_vm.uploadBtnText))])])}
var staticRenderFns = []

export { render, staticRenderFns }